import { render, staticRenderFns } from "./PesosCocidosList.vue?vue&type=template&id=48f438b8&scoped=true"
import script from "./PesosCocidosList.vue?vue&type=script&lang=js"
export * from "./PesosCocidosList.vue?vue&type=script&lang=js"
import style0 from "./PesosCocidosList.vue?vue&type=style&index=0&id=48f438b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f438b8",
  null
  
)

export default component.exports